"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePresetAction = void 0;
var typeorm_1 = require("typeorm");
var GamePreset_entity_1 = require("./GamePreset.entity");
var GamePresetAction = /** @class */ (function () {
    function GamePresetAction() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], GamePresetAction.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], GamePresetAction.prototype, "triggerRoundID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], GamePresetAction.prototype, "actionUpdateType", void 0);
    __decorate([
        (0, typeorm_1.Column)({ nullable: true }),
        __metadata("design:type", Number)
    ], GamePresetAction.prototype, "entryID", void 0);
    __decorate([
        (0, typeorm_1.Column)({ nullable: true }),
        __metadata("design:type", String)
    ], GamePresetAction.prototype, "settingValue", void 0);
    __decorate([
        (0, typeorm_1.Column)({ type: 'json', nullable: true }),
        __metadata("design:type", Object)
    ], GamePresetAction.prototype, "actionParameters", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return GamePreset_entity_1.GamePreset; }, function (preset) { return preset.gamePresetActions; }),
        __metadata("design:type", GamePreset_entity_1.GamePreset)
    ], GamePresetAction.prototype, "preset", void 0);
    GamePresetAction = __decorate([
        (0, typeorm_1.Entity)({ name: 'game_preset_actions' })
    ], GamePresetAction);
    return GamePresetAction;
}());
exports.GamePresetAction = GamePresetAction;
//# sourceMappingURL=GamePresetAction.entity.js.map